import React, {Fragment, useEffect, useState} from "react";
import ErrorPage from 'next/error'
import {approx, createDataTree, getRelatedPosts, objectToArray, timeSince} from "../../utilities/utils";
import {
    reportPost,
    toggleBookmarkPost,
    toggleDislikePost,
    toggleLikePost
} from "../../screens/main/postDetails/PostDetailsActions";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import size from "lodash/size";
import map from "lodash/map";
import has from "lodash/has";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {Carousel} from "react-bootstrap";
import Link from "next/link";
import {
    EmailIcon,
    EmailShareButton,
    FacebookIcon,
    FacebookShareButton,
    TwitterIcon,
    TwitterShareButton,
    WhatsappIcon,
    WhatsappShareButton
} from "react-share";
import PostDetailsComments from "../../screens/main/postDetails/PostDetailsComments";
import {TwitterVideoEmbed} from "react-twitter-embed";
import InstagramEmbed from "react-instagram-embed";
import {NextSeo} from "next-seo";
import Layout from "../../features/nav/Layout";

import 'semantic-ui-css/components/popup.min.css'
import 'semantic-ui-css/components/button.min.css'
import 'semantic-ui-css/components/header.min.css'
import 'semantic-ui-css/components/segment.min.css'
import {Button, Header, Popup, Segment} from "semantic-ui-react";
import {database} from "../../config/firebase";
import {onValue, ref} from "firebase/database";
import RelatedPosts from "../../components/RelatedPosts";
import {useUser} from "../../context/userContext";
import {useRouter} from "next/router";
import PostDetailsCommentForm from "../../screens/main/postDetails/PostDetailsCommentForm";
import {getPost} from "../../utilities/posts";


const Post = ({relatedPosts, postData}) => {

    const {query: {id: postId}} = useRouter();
    const instaToken = "242345596909580|8e54b5ef7f10d84b147e292dcb833466";

    let post = useSelector((state) => state.posts[postId], shallowEqual())
    if (isEmpty(post)) {
        post = postData
    }
    const [comments, setComments] = useState(null);
    const {userId} = useUser()
    const commentsPath = `comments/${postId}`
    const commentsRef = ref(database, commentsPath);
    const dispatch = useDispatch()


    useEffect(() => {
        onValue(commentsRef, (snapshot) => {
            const data = snapshot.val();
            setComments(objectToArray(data))
        });
        return () => {
            setComments(null)
        };
    }, [postId])

    const renderRelatedPosts = () => {
        return (
            <>
                <Segment
                    textAlign='center'
                    attached='top'
                    inverted
                    className={'border-0'}
                    style={{backgroundColor: '#008B4B'}}
                >
                    <Header>Related Stories</Header>
                </Segment>
                <RelatedPosts relatedPosts={relatedPosts} searchTerm={postData['groupName']}/>
            </>
        )
    }

    if (!post?.authorId) {
        return (
            <Layout mainContent={
                <ErrorPage statusCode={404}/>
            }/>
        )
    }


    if (post) {
        let {
            title,
            description,
            groupId,
            groupName,
            timeStamp,
            diffVoteCnt,
            id,
            isGraphic,
            isProfane,
            youtubeIds,
            images,
            author,
            urls,
            type,
            video,
            authorId,
            bookmarkers,
            likers,
            dislikers,
            webUrl,
            source
        } = post;
        let time = typeof timeStamp === 'object' ? timeSince(timeStamp.toDate()) : timeSince(new Date(timeStamp))

        let link;
        if (isEmpty(urls)) {
            link = webUrl
        } else {
            link = urls[0]
        }

        let metaUrl = 'https://naijaworld.com/p/'.concat(id);
        let metaImages = []

        if (!isEmpty(images)) {
            for (const image of images) {
                let metaImageUrl = get(image, 'url', image)
                metaImages.push({url: metaImageUrl, alt: title})
            }
        } else {
            if (!isEmpty(youtubeIds)) {
                let metaImageUrl = `https://i.ytimg.com/vi/${youtubeIds[0]}/hqdefault.jpg`
                metaImages.push({url: metaImageUrl, alt: title})
            }
            if (!isEmpty(video)) {
                let metaImageUrl = `https://i.ytimg.com/vi/${video['url']}/hqdefault.jpg`
                metaImages.push({url: metaImageUrl, alt: title})
            }
        }

        let ftcId = !isEmpty(comments) && (comments[0].aId !== authorId) && comments[0].aId;
        let chatTree = !isEmpty(comments) && createDataTree(comments, authorId, ftcId);

        const getTweetID = (tweetUrl) => {
            const statusRegEx = /.*twitter.com\/.*status\/(\d+)/g;
            const match = statusRegEx.exec(tweetUrl);
            if (match) {
                return match[1]
            }
        }
        let tweetIDs = new Set()

        if (!isEmpty(urls)) {
            for (const url of urls) {
                let tweetID = getTweetID(url)
                if (tweetID) {
                    tweetIDs.add(tweetID)
                }
            }
        }

        if (webUrl) {
            let tweetID = getTweetID(webUrl)
            tweetIDs.add(tweetID)
        }

        tweetIDs = Array.from(tweetIDs)
        //todo add tweetIDs to new post function

        let ldjsonMetaImages = map(metaImages, 'url')

        return (
            <div>
                <NextSeo
                    title={title}
                    description={description}
                    canonical={metaUrl}
                    openGraph={{
                        url: metaUrl,
                        title: title,
                        description: description,
                        images: isEmpty(metaImages) ? null : metaImages
                    }}
                />
                <Layout mainContent={
                    <div className={'m-3'} style={{wordBreak: "break-word"}}>
                        <h2 className={'font-weight-bold'} style={{
                            lineHeight: 1.05
                        }}>{title}</h2>
                        <div className={'d-flex flex-row justify-content-between align-items-center pb-2 text-left'}>
                            <div>
                                <div className={'d-flex text-muted text-lowercase'}>
                                    <Link href="/u/[id]" as={`/u/${authorId}`}>
                                        <a className={'pr-1 border-right border-success'}>
                                            @{author}
                                        </a>
                                    </Link>
                                    <Link href="/g/[id]" as={`/g/${groupId}`}>
                                        <a className={'px-1 border-right border-success'}>
                                            {groupName}
                                        </a>
                                    </Link>
                                    <div className={'pl-1'} style={{minWidth: 25}}>
                                        {time}
                                    </div>
                                </div>
                                {source && !['facebook', 'twitter', 'youtube'].includes(source) &&
                                    <small>
                                        source: {source}
                                    </small>
                                }
                            </div>
                            <div style={{minWidth: 100}} className={'pl-1'}>
                                <Popup content='report post' trigger={<Button icon='exclamation triangle'
                                                                              onClick={() => dispatch(reportPost(post))}/>}
                                       size={'mini'}/>
                                <Popup content='save post' trigger={<Button
                                    icon={bookmarkers.includes(userId) ? 'bookmark' : 'bookmark outline'}
                                    color={bookmarkers.includes(userId) ? 'green' : null}
                                    onClick={() => dispatch(toggleBookmarkPost(post, userId))}
                                />} size={'mini'}/>
                            </div>
                        </div>

                        <div className={"d-flex flex-row justify-content-between pb-2 border-bottom"}>
                            <Fragment>
                                <div className={'d-flex flex-row justify-content-between align-items-center'}
                                     style={{width: '110px'}}>
                                    <Button icon={'thumbs up'}
                                            onClick={() => dispatch(toggleLikePost(post, userId))}
                                            color={likers.includes(userId) ? 'green' : null} circular size={'mini'}/>
                                    <div>{approx(diffVoteCnt, 1)}</div>
                                    <Button icon={'thumbs down'} color={dislikers.includes(userId) ? 'red' : null}
                                            onClick={() => dispatch(toggleDislikePost(post, userId))} circular
                                            size={'mini'}/>
                                </div>
                            </Fragment>

                            <div className={'d-flex flex-row justify-content-between'} style={{width: '145px'}}>
                                <FacebookShareButton
                                    url={'https://naijaworld.com/'.concat('p/', id)}
                                    quote={title}
                                >
                                    <FacebookIcon size={32} round/>
                                </FacebookShareButton>
                                <WhatsappShareButton
                                    url={'https://naijaworld.com/'.concat('p/', id)}
                                    title={title}
                                >
                                    <WhatsappIcon size={32} round/>
                                </WhatsappShareButton>
                                <TwitterShareButton
                                    url={'https://naijworld.com/'.concat('p/', id)}
                                    title={title}
                                >
                                    <TwitterIcon size={32} round/>
                                </TwitterShareButton>
                                <EmailShareButton
                                    body={'https://naijaworld.com/'.concat('p/', id)}
                                    subject={title}
                                >
                                    <EmailIcon size={32} round/>
                                </EmailShareButton>
                            </div>
                        </div>
                        <div className={"my-2"}>
                            {(!isEmpty(youtubeIds) || !isEmpty(video)) &&
                                <iframe allowFullScreen className={"d-block w-100"} height={"300"}
                                        src={`https://www.youtube.com/embed/${get(video, 'url', false) || youtubeIds[0]}?loop=1`}
                                        title={title}>
                                </iframe>
                            }
                        </div>
                        {size(images) === 1 && (typeof (images[0]) === 'string') &&
                            <div style={{
                                backgroundImage: `url(${images[0]})`,
                            }} className={'post-image'}/>
                        }
                        {size(images) === 1 && (typeof (images[0]) === 'object') &&
                            <div>
                                <div style={{
                                    backgroundImage: `url(${images[0].url})`,
                                }} className={'post-image'}/>
                                <div className={'bg-dark text-white text-center'}>
                                    {images[0].caption}
                                </div>
                            </div>
                        }
                        {size(images) > 1 &&
                            <Carousel>
                                {(typeof (images[0]) === 'string') && images.map(image => (
                                    <Carousel.Item key={image}>
                                        <div style={{
                                            backgroundImage: `url(${image})`,
                                        }} className={'post-image'}/>
                                    </Carousel.Item>
                                ))}
                                {(typeof (images[0]) === 'object') && images.map(image => (
                                    <Carousel.Item key={image}>
                                        <div style={{
                                            backgroundImage: `url(${image.url})`,
                                        }} className={'post-image'}/>
                                        <Carousel.Caption>
                                            <h4 style={{
                                                mixBlendMode: 'difference',
                                                opacity: 0.7
                                            }} className={"text-white bg-dark"}>{image.caption}</h4>
                                        </Carousel.Caption>
                                    </Carousel.Item>
                                ))}
                            </Carousel>
                        }
                        <p style={{
                            fontSize: 16,
                            // fontFamily: 'sans-serif',
                            whiteSpace: 'pre-wrap',
                        }} className={'my-1 font-family-sans-serif'}>
                            {description}
                        </p>
                        {
                            !isEmpty(tweetIDs) && tweetIDs.map((tweetID) => (
                                    <div id={tweetID}>
                                        <TwitterVideoEmbed
                                            id={tweetID}
                                        />
                                    </div>
                                )
                            )
                        }
                        {
                            !isEmpty(urls) && urls.map((url) => (
                                    url.includes('instagram.com/p/') &&
                                    <InstagramEmbed
                                        url={url}
                                        clientAccessToken={instaToken}
                                        key={url}
                                    />
                                )
                            )
                        }
                        {
                            webUrl && webUrl.includes('instagram.com/p/') &&
                            <InstagramEmbed
                                url={webUrl}
                                clientAccessToken={instaToken}
                                key={webUrl}
                            />
                        }
                        <div className={'mb-3'}>
                            {Boolean(link) && !['twitter', 'instagram'].includes(source) &&
                                <Button fluid onClick={() => window.open(link, "_blank")}>See more
                                    on {source}</Button>
                            }
                        </div>

                        <div
                            className={'bg-light text-dark border p-2 text-center rounded'}>
                            <div>
                                <h5>Use The App To Win N1m</h5>
                            </div>
                            <div className={'d-flex justify-content-between flex-row'}>
                                <img
                                    alt=""
                                    src="/google-play-badge.png"
                                    width="45%"
                                    onClick={() => window.open('https://play.google.com/store/apps/details?id=online.naijaworld.app', "_blank")}
                                />
                                <img
                                    alt=""
                                    src="/ios-app-store-badge.png"
                                    width="45%"
                                    onClick={() => window.open('https://apps.apple.com/gb/app/naijaworld/id1482971283', "_blank")}
                                />
                            </div>
                        </div>
                        <br/>
                        <div className={'bg-light text-dark border small p-2 text-center rounded'}>
                            NB: Stories are shared by community members. The article does NOT represent the official
                            view of NaijaWorld and
                            the author is SOLELY RESPONSIBLE for this article
                        </div>
                        <Fragment>
                            <Segment
                                textAlign='center'
                                attached='top'
                                inverted
                                className={'border-0'}
                                style={{backgroundColor: '#008B4B'}}
                            >
                                <Header>Comments</Header>
                            </Segment>

                            <Segment attached>
                                <PostDetailsComments comments={chatTree} postId={postId}
                                                     postAuthorId={post.authorId}
                                                     userId={userId}/>

                                <PostDetailsCommentForm
                                    postAuthorId={post.authorId}
                                    postId={postId}
                                    form={'newComment'}
                                    isEmpty={isEmpty(comments)}
                                />
                            </Segment>
                        </Fragment>

                        <br/>
                        <div className={'d-lg-none pt-3'}>
                            {renderRelatedPosts()}
                        </div>
                    </div>
                } sidebarContent={
                    <div className={'d-none d-lg-block p-3'}>
                        {renderRelatedPosts()}
                    </div>
                }/>
            </div>
        );
    }
    return <div/>
}

export async function getStaticPaths() {
    return {
        paths: [
            {params: {id: '003yStYlqVDBMm7GUYlh'}}
        ],
        fallback: "blocking"
    };
}

export async function getStaticProps({params}) {
    const postId = params.id
    const postData = await getPost(postId);
    let relatedPosts = [];
    if (has(postData, 'groupName')) {
        relatedPosts = await getRelatedPosts(postData['groupName']);
    }
    relatedPosts = relatedPosts.filter((post) => post['id'] !== postId)

    return {
        props: {
            postId,
            postData,
            relatedPosts
        },
        revalidate: 1800
    }
}

export default Post